import { module } from "angular";
import { DeleteButtonComponent } from "./DeleteButtonComponent";

module("mmGui").component("irDeleteButton", new DeleteButtonComponent());
